import { useEffect } from "react";
import { FlowState } from "./types";
import { AxiosInstance } from "axios";

export const useSessionKeepAlive = (flowState: FlowState, apiClient: AxiosInstance) => {
  useEffect(() => {
    const keepAliveStates: FlowState[] = [
      "generalExtracted",
      "detailedExtracted",
    ];
    let intervalId: NodeJS.Timeout | null = null;

    const keepSessionAlive = async () => {
      try {
        await apiClient.get("/api/auth/keep-alive");
        console.log("Session extended.");
      } catch (error) {
        console.error("Failed to keep session alive:", error);
      }
    };

    if (keepAliveStates.includes(flowState)) {
      // Call it once immediately, then set the interval
      keepSessionAlive();
      intervalId = setInterval(keepSessionAlive, 900000); // 15 minutes
    }

        return () => {
          if (intervalId) {
            clearInterval(intervalId);
          }
        };
      }, [flowState, apiClient]);
};